import axios from "axios";
import { requestCounter } from "./RequestCounter";
import { mapApiError } from "../../services/apiErrorMapper";
import { errorBus } from "../errorBus";
import { jwtDecode } from "jwt-decode";
import store from "../../redux/store";
import { refresh_token } from "../../redux/authSlice";

export const axiosClient = axios.create({
  baseURL: "/api",
});

/** Single in-flight refresh shared by concurrent interceptors (avoids /auth/refresh 429). */
let refreshPromise = null;

const fetchNewAccessToken = () => {
  if (!refreshPromise) {
    refreshPromise = (async () => {
      const user = JSON.parse(localStorage.getItem("user"));
      const oldRefreshToken = localStorage.getItem("refresh_token");

      if (!oldRefreshToken) {
        throw new Error("No refresh token available");
      }

      const response = await axios.post("/api/auth/refresh/", {
        username: user.email,
        token: oldRefreshToken,
      });
      store.dispatch(refresh_token(response.data));

      return response.data.accessToken;
    })().finally(() => {
      refreshPromise = null;
    });
  }

  return refreshPromise;
};

axiosClient.interceptors.request.use(
  async (config) => {
    requestCounter.increment();
    let accessToken = localStorage.getItem("access_token");

    if (accessToken) {
      const decodedToken = jwtDecode(accessToken);
      const isExpired = decodedToken.exp * 1000 < Date.now();
      if (isExpired) {
        try {
          accessToken = await fetchNewAccessToken();
        } catch (error) {
          console.error("Failed to refresh token:", error);
        }
      }
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    requestCounter.decrement();
    return Promise.reject(error);
  },
);

axiosClient.interceptors.response.use(
  (response) => {
    requestCounter.decrement();
    return response;
  },
  (error) => {
    requestCounter.decrement();

    const mappedError = mapApiError(error);
    errorBus.emit(mappedError);

    return Promise.reject(mappedError);
  },
);
